import { observer } from 'mobx-react-lite'
import React from 'react'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'
import { ChevronRight } from '@mxenabled/mx-icons'

import { Dialog, useGlobalCopyStore, useSettingsStore, useUserStore } from '../../../../common'

const VerifyEmailAction = observer(() => {
  const { common: commonCopy, settings: settingsCopy } = useGlobalCopyStore()
  const { sendEmailVerification } = useSettingsStore()
  const { user } = useUserStore()
  const theme = useTheme()

  const [isOpen, setIsOpen] = React.useState(false)

  const handleClose = (): void => {
    setIsOpen(false)
  }

  const handleOpen = (): void => {
    setIsOpen(true)
  }

  return (
    <React.Fragment>
      <Button onClick={handleOpen} sx={{ height: 'auto', p: 4, width: 'fit-content' }}>
        <Text variant="body2">{settingsCopy.verify_email}</Text>
        <ChevronRight />
      </Button>
      <Dialog
        copy={{ title: settingsCopy.confirm_your_email }}
        isOpen={isOpen}
        onClose={handleClose}
        onPrimaryAction={sendEmailVerification}
        onSecondaryAction={handleClose}
        primaryText={settingsCopy.send_verification}
        secondaryText={commonCopy.back}
      >
        <Stack spacing={16} sx={{ px: 40, textAlign: 'center', width: '100%' }}>
          <Text truncate={false} variant="body2">
            {settingsCopy.confirm_email}
          </Text>
          <Text
            sx={{
              border: `1px solid ${theme.palette.neutral.light}`,
              borderRadius: '4px',
              p: '16px 32px',
            }}
            variant="h3"
          >
            {user.email}
          </Text>
          <Text truncate={false} variant="body2">
            {settingsCopy.verification_notice_email}
          </Text>
        </Stack>
      </Dialog>
    </React.Fragment>
  )
})

export default VerifyEmailAction
